import { connect } from 'react-redux';
import { userAvatar as chatUserAvatarSelector } from 'app-modules/chat/selectors';
import * as selectors from '../selectors';
import { TriviaLeaderboardComponent } from '../components/Leaderboard';

const mapStateToProps = (state) => ({
  myScore: selectors.userScore(state),
  myPosition: selectors.userRanking(state).position,
  myAvatar: chatUserAvatarSelector(state),
  leaderboardData: selectors.leaderboardData(state),
});

export const TriviaLeaderboard = connect(mapStateToProps)(TriviaLeaderboardComponent);
